import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useModal, useTranslate } from "@refinedev/core";
import { ExceptionAddDialog } from "./ExceptionAddDialog";

export const ExceptionAddButton = () => {
  const translate = useTranslate();
  const { show, close, visible } = useModal();

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        sx={{ width: "100px" }}
        startIcon={<Add />}
        onClick={show}
      >
        {translate("buttons.add")}
      </Button>
      <ExceptionAddDialog open={visible} onClose={close} />
    </>
  );
};
